import { MessagesState } from "@/lib/core/crm/types";

export function createInitialState(): MessagesState {
  return {
    messagesByInbox: {},
    loadingStates: {},
    errorStates: {},
    paginationInfo: {},
    unreadCounts: {},
  };
}
